(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstancesController', InstancesController);

    InstancesController.$inject = ['InstancesService', '$uibModal', 'ParseLinks', 'pagingParams', 'paginationConstants', 'AlertService'];

    function InstancesController(InstancesService, $uibModal, ParseLinks, pagingParams, paginationConstants, AlertService) {
        var vm = this;

        vm.regions = {
            "us-east-1": "US East (N. Virginia)",
            "us-east-2": "US East (Ohio)",
            "us-west-1": "US West (N. California)",
            "us-west-2": "US West (Oregon)",
            "eu-central-1": "EU (Frankfurt)",
            "eu-west-1": "EU (Ireland)",
            "eu-west-2": "EU (London)"
        };

        vm.instances = {};
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.runningAndStopped = true;
        vm.showOnlyRunningAndStoppedInstances = showOnlyRunningAndStoppedInstances;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.terminate = terminate;
        vm.editInstance = editInstance;
        vm.saveInstance = saveInstance;
        vm.allowPersonal = saveInstance;

        vm.loadAll({
            page: 0,
            sort: vm.predicate + (vm.reverse ? ',asc' : ',desc')
        }, vm.runningAndStopped);

        function loadAll(pageable, runningAndStopped) {
            InstancesService.getInstances(pageable, runningAndStopped).then(function (response) {
                vm.links = ParseLinks.parse(response.headers('link'));
                vm.totalItems = response.headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instances = response.data;
            });
        }

        function transition() {
            vm.loadAll({
                page: vm.page - 1,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, vm.runningAndStopped);
        }

        function terminate(instanceId) {
            InstancesService.terminateInstance(instanceId).success(function (response) {

            }).error(function (error, status) {
                AlertService.error(error.detail);
            });
        }

        function editInstance(instance) {
            instance.editMode = true;
        }

        function saveInstance(instance) {
            InstancesService.saveInstance(instance).success(function (response) {
                instance.editMode = false;
            }).error(function (error, status) {
                AlertService.error(error.detail);
            });
        }

        function showOnlyRunningAndStoppedInstances() {
            vm.loadAll({
                page: 0,
                sort: vm.predicate + (vm.reverse ? ',asc' : ',desc')
            }, vm.runningAndStopped);
        }
    }
})();
